export const COLORS = {
  primary: '#9CD1E4',
  secondary: "#4A4A4A",
  light:"#EEEEEE",
  danger:"#F39DAA",
  validation:"#BCE49C"
}
